import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, Link, useNavigate } from "react-router-dom";
import { API_cursos } from "../../config/apiConfig";
import {
  FaArrowUpRightFromSquare,
  FaBuilding,
  FaCalendarDay,
  FaClock,
  FaLocationDot,
  FaUser,
  FaUsers,
} from "react-icons/fa6";
import Navbar from "../../components/Navbar";
import "./css/NuevosRecursos.css";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext";
import { API_BASE_URL } from "../../config/apiConfig";

const OfertaFormacion = () => {
  const { id } = useParams();
  const { role } = useSelector((state) => state.auth);
  const [curso, setCurso] = useState(null);
  const [loading, setLoading] = useState(true);
  const { token } = useAuth();

  /* Botón eliminar curso */
  const [mostrarModal, setMostrarModal] = useState(false);
  const navigate = useNavigate();

  const handleCancelar = () => {
    setMostrarModal(true);
  };

  const deleteCurso = async () => {
    try {
      const url = `${API_cursos}/${id}`;
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "x-auth-token": token,
        },
      });

      if (response.ok) {
        // Navegar de vuelta a la lista de cursos después de eliminar
        navigate("/admin/formacion");
        toast.success("Curso eliminado correctamente");
      } else {
        console.error("Error al eliminar el curso:", response.statusText);
        toast.error("Error al eliminar el curso");
      }
    } catch (error) {
      console.error("Error al eliminar el curso:", error);
      toast.error("Error al eliminar el curso");
    }
  };

  useEffect(() => {
    const fetchCurso = async () => {
      try {
        const response = await fetch(API_cursos, {
          headers: {
            "x-auth-token": token,
          },
        });
        const data = await response.json();

        // Buscar el curso por _id
        const encontrada = data.find((curso) => curso._id === id);
        setCurso(encontrada || null);
      } catch (error) {
        console.error("Error al obtener el curso:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCurso();
  }, [id, token]);

  const formatearFecha = (fecha) => {
    const date = new Date(fecha);
    return date.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  if (loading) return <p>Cargando curso...</p>;
  if (!curso) return <p>No se encontró el curso.</p>;

  return (
    <>
      <Navbar />

      <main className="main ofertas-usuario">
        <section className="cabecera between">
          <div className="column gap-5">
            <h1 className="titulo-user">{curso.title}</h1>
            {/* <h2 className="font-21">Sector: Alimentación</h2> */}
            <p className="bold font-18">
              Inscripción: {formatearFecha(curso.initialRegistration)} -{" "}
              {formatearFecha(curso.finalRegistration)}
            </p>
          </div>

          <div className="flex gap-10">
            {/* Botones editar y eliminar curso - solo para administradores y tecnico-1 */}
            {(role === "administrador" || role === "tecnico-1") && (
              <Link
                className="boton"
                to={`/admin/nueva-formacion/${curso._id}`}
              >
                Editar la información del curso
              </Link>
            )}
            {role === "administrador" && (
              <button
                className="eliminar fondo-rojo blanco"
                onClick={handleCancelar}
              >
                Eliminar este curso
              </button>
            )}
          </div>
        </section>

        {mostrarModal && (
          <div className="ventana-cancelar fondo-blanco">
            <div className="column gap-5">
              <p>
                ¿Estás seguro que quieres eliminar el curso?<br></br>Una vez
                eliminada no habrá forma de recuperarlo
              </p>
              <div className="botones flex gap-20">
                <button className="fondo-rojo blanco" onClick={deleteCurso}>
                  Eliminar curso
                </button>
                <button
                  className="seguir blanco fondo-verde"
                  onClick={() => setMostrarModal(false)}
                >
                  Mantener curso
                </button>
              </div>
            </div>
          </div>
        )}

        <section className="contenido-principal between">
          <div>
            <p className="bold mb-10">
              Modalidad: <span className="rosa">{curso.modality}</span>
            </p>
            <p className="w-100">{curso.description}</p>

            {/* Mostrar imagen si existe */}
            {curso.imageUrl &&
              curso.imageUrl !== "/images/default-course.jpg" && (
                <div className="imagen-recurso mt-20">
                  <img
                    src={
                      curso.imageUrl.startsWith("http")
                        ? curso.imageUrl
                        : `${API_BASE_URL}/downloads/formaciones/${curso.imageUrl}`
                    }
                    alt={curso.title}
                    className="imagen-detalle"
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              )}
          </div>

          <div className="caracteristicas column gap-10">
            <p>
              <span className="rosa">
                <FaBuilding />
              </span>
              {curso.institutionalFacility}
            </p>
            <p>
              <span className="rosa">
                <FaLocationDot />
              </span>
              {curso.location}
            </p>
            <p>
              <span className="rosa">
                <FaCalendarDay />
              </span>
              {formatearFecha(curso.startDate)} -{" "}
              {formatearFecha(curso.endDate)}
            </p>
            <p>
              <span className="rosa">
                <FaClock />
              </span>
              {curso.duration} horas
            </p>
            <p>
              <span className="rosa">
                <FaUser />
              </span>
              {curso.targetUsers}
            </p>
            <p>
              <span className="rosa">
                <FaUsers />
              </span>
              {curso.seats} plazas
            </p>
            {curso.link && (
              <a
                href={curso.link}
                target="_blank"
                rel="noopener noreferrer"
                className="rosa align-center"
              >
                <span className="rosa">
                  <FaArrowUpRightFromSquare />
                </span>{" "}
                Link a la formación
              </a>
            )}
          </div>
        </section>
      </main>
    </>
  );
};

export default OfertaFormacion;
